module.exports = __webpack_public_path__ + "static/media/cafe_logo_green_23.8de0fd22.png";